<template>
  <div class="date-time">
    <div class="date-time-input mb-3" @click="showDate = true">
      <i class="el-icon-date mr-2"></i>
      <span v-if="!smallForm.start" class="date-time-placeholder">{{ startPlaceholder }}</span>
      <template v-else>
        <span>{{ smallForm.start }}</span>
<!--        <i class="el-icon-circle-close flex-1" @click.stop="resetForm"></i>-->
      </template>
    </div>
    <div class="date-time-input" @click="showDate = true">
      <i class="el-icon-date mr-2"></i>
      <span v-if="!smallForm.end" class="date-time-placeholder">{{ endPlaceholder }}</span>
      <template v-else>
        <span>{{ smallForm.end }}</span>
<!--        <i class="el-icon-circle-close flex-1" @click.stop="resetForm"></i>-->
      </template>
    </div>
    <van-calendar
        ref="dateRef"
        v-model="showDate"
        :min-date="minDate"
        :max-date="maxDate"
        color="#5BC17F"
        type="range"
        @confirm="onConfirm"/>
  </div>
</template>

<script>
import {
  isEmpty,
  formatDate
} from "@/util/util"
export default {
  name: "smallVanCalendar",
  props:{
    startPlaceholder:{
      type:String,
      default:()=>{
        return '请选择开始时间'
      }
    },
    endPlaceholder:{
      type:String,
      default:()=>{
        return '请选择结束时间'
      }
    }
  },
  data() {
    return {
      smallForm:{
        date:'',
        start:'',
        end:''
      },
      showDate: false,
      minDate:new Date(2000, 0, 1),
      maxDate:new Date(2027, 0, 31),
      year:''
    }
  },
  methods:{
    setValue(dateArr){
      if(!isEmpty(dateArr)){
        this.smallForm.start = this.$moment(dateArr[0]).format('YYYY-MM-DD');
        this.smallForm.end = this.$moment(dateArr[1]).format('YYYY-MM-DD');
        //calendar
        this.$refs.dateRef.reset(dateArr)
      }
    },
    onConfirm(date){
      this.showDate = false;
      const [start, end] = date;
      this.year = start.getFullYear();
      this.smallForm.date = `${this.year}-${formatDate(start)} ─ ${this.year}-${formatDate(end)}`;
      this.smallForm.start = `${this.year}-${formatDate(start)}`;
      this.smallForm.end = `${this.year}-${formatDate(end)}`;
      this.$emit('confirmDateRange',this.smallForm.start,this.smallForm.end)
    },
    async getDate(){
      return new Promise((resolve)=>{
        let monthDateArr = this.smallForm.date.split('─');
        this.smallForm.start = monthDateArr[0];
        this.smallForm.end = monthDateArr[1];
        resolve()
      })
    },
    resetForm(){
      Object.assign(this.$data.smallForm, this.$options.data().smallForm);
    }
  }
}
</script>
